import { useCallback, useEffect, useState } from "react";
import request from "../api/request";
import { Prize } from "../api/types";
import { useNavigate } from "react-router-dom";

import './Gachapon.scss';
import './Prizes.scss';


const getProb = (type:string) => {
    switch (type) {
      case "jackpot":
          return "1%"
        break;
      case "grand":
          return "3%"
        break;
      case "rabbit":
          return "0.5%"
        break;
    case "spl_token":
          return "15%"
        break;
    case "raffle_ticket":
          return "35%"
        break;
    case "spin_token":
          return "25%"
        break;
      default:
        break;
    }
  }

const Prizes = () => {
   let [prizes, setPrizes] = request<Prize[]>('/prizes', {}, true);
   let [showPrizes, setShowPrizes] = useState<any>(null)
   let [currentFilter, setFilter] = useState("jackpot")
   let [showItems, setShowItems] = useState(0)
   let navigate = useNavigate();

   const loadTab = (prizesArr:any) => {
        let filteredPrizes = prizesArr.filter((p:any) => { return p.type === currentFilter})
        setShowItems(filteredPrizes.length)
   }

   useEffect(() => {
      if(prizes && showPrizes === null){
        setShowPrizes(prizes)
        loadTab(prizes)
      }
   }, [prizes])

   useEffect(() => {
    if(showPrizes){
        loadTab(showPrizes)
    }
   }, [currentFilter])

    return (
        <div className="Gachapon--Wrapper">
           <div className="Gachapon--Header Gachapon--Header--Prizes Gachapon--Header--Start">

                <div className="Prizes--Header--Logo">
                    <img src={process.env.PUBLIC_URL + '/images/flippinrabbits-logo.png'} alt="" />
                    <div className="Prizes--Header--Container">
                        <h1 className="header-title">Flippin' Prizes</h1>
                        <span>Are you feeling lucky? These are the prizes you can win at Flippin' Gach</span>
                    </div>
                </div>
                <div className="return" onClick={() => { navigate("/") }}>Go to Flippin' Gach</div>
            
            </div>
            <div className="Gachapon--Prizepool--Selector">
                <span className={currentFilter === "jackpot" ? "active" : ""} onClick={() => { setFilter("jackpot") }}>Jackpot Prizes</span>
                <span className={currentFilter === "grand" ? "active" : ""} onClick={() => { setFilter("grand") }}>Grand Prizes</span>
            </div>
            <div className="Gachapon--Prizepool">
                {showItems > 0 && showPrizes.map((prize:any, index:number) => (
                    <div key={index} className={`Gachapon--Prizepool--Image ${prize.type===currentFilter? "show" : ""}`}>
                        <img alt={prize.mint} src={`https://img-cdn.magiceden.dev/rs:fill:640:640:0:0/plain/${prize.image}`} />
                        <span>{prize.name}</span>
                        <span className="Gachapon--Prizepool--Prob">Win: {getProb(prize.type)}</span>
                    </div>
                ))}
                {showItems === 0 && <div className="Gachapon--Prizepool-None">Nothing in here?<br/>Don't worry, Flippin' Gach will be refilled soon.</div>}
            </div>
        </div>
    )
}

export default Prizes;